var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIconRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash 1",
    clipPath: "url(#clip0_217_1588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4584 2.4375C12.4584 1.98877 12.0947 1.625 11.6459 1.625H9.60059C9.25832 0.653986 8.34215 0.00330078 7.31259 0H5.68759C4.65803 0.00330078 3.74186 0.653986 3.39959 1.625H1.35425C0.90552 1.625 0.541748 1.98877 0.541748 2.4375C0.541748 2.88623 0.90552 3.25 1.35425 3.25H1.62509V10.0208C1.62509 11.6662 2.95891 13 4.60425 13H8.39591C10.0413 13 11.3751 11.6662 11.3751 10.0208V3.25H11.6459C12.0947 3.25 12.4584 2.88623 12.4584 2.4375ZM9.75009 10.0208C9.75009 10.7687 9.14381 11.375 8.39593 11.375H4.60425C3.85637 11.375 3.25009 10.7687 3.25009 10.0208V3.25H9.75009V10.0208Z",
    fill: "#E80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.146 9.75C5.59472 9.75 5.9585 9.38623 5.9585 8.9375V5.6875C5.9585 5.23877 5.59472 4.875 5.146 4.875C4.69727 4.875 4.3335 5.23877 4.3335 5.6875V8.9375C4.3335 9.38623 4.69727 9.75 5.146 9.75Z",
    fill: "#E80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.85425 9.75C8.30298 9.75 8.66675 9.38623 8.66675 8.9375V5.6875C8.66675 5.23877 8.30298 4.875 7.85425 4.875C7.40552 4.875 7.04175 5.23877 7.04175 5.6875V8.9375C7.04175 9.38623 7.40552 9.75 7.85425 9.75Z",
    fill: "#E80000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconRed);
export default __webpack_public_path__ + "static/media/trashIcon-red.313a662d37b128ae43e5e0addd6691b6.svg";
export { ForwardRef as ReactComponent };